import Form from '@rjsf/core';
import type { RJSFSchema, UiSchema } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';

import { ObjectFieldTemplateReader } from '@/components/forms/components/formTemplates/objectFieldWriter';
import type { WorkflowContext } from '@/components/forms/utils/workflowContext';
import ArrayFieldTemplate from './arrayFieldTemplate';
import { fieldsReader } from './fields';
import FieldTemplate from './fieldTemplate';
import { readerWidgets } from './widgets';

type Props = {
  schema: RJSFSchema;
  uiSchema: UiSchema;
  formData: Record<string, unknown>;
  downloadFile: () => void;
  workflowContext?: WorkflowContext;
  downloadAllFiles: () => void;
};

export const FormReader = ({
  schema,
  uiSchema,
  formData,
  downloadFile,
  workflowContext,
  downloadAllFiles
}: Props) => (
  <Form
    disabled
    fields={fieldsReader}
    formContext={{
      downloadFile,
      workflowContext,
      downloadAllFiles
    }}
    formData={formData}
    noHtml5Validate
    noValidate
    schema={schema}
    showErrorList={false}
    templates={{
      FieldTemplate: FieldTemplate as any,
      ObjectFieldTemplate: ObjectFieldTemplateReader,
      ArrayFieldTemplate
    }}
    uiSchema={uiSchema}
    validator={validator}
    widgets={readerWidgets as any}
  >
    <button className="hidden" type="submit" />
  </Form>
);
